import React, { useEffect } from 'react';
import '../PlatformCostObs/dashboard.scss';
import PageHeader from 'components/Header/Page';
import { powerBIdashboardUrl } from '../../service/config';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import BIApplicationIcon from '../../assets/biApplication.svg';
import PageWrapper from 'components/Common/PageWraper';
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const NPIDashboards = () => {
    const theme = useTheme();
    const [controller] = usePepwiseAuthController();
    const { role } = controller;
    const [value, setValue] = React.useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        const activeId = document.getElementById('root');
        console.log(window.location.pathname);
        if (window.location.pathname.includes('/D&AIXOps') && role !== "Program Executive") {
            if (activeId) {
                document.head.classList.add('theme-bg-blue');
                document.body.classList.add('theme-bg-blue');
            }
        }
    }, []);

    return (
        // <div className="base-tab">
            <PageWrapper>
                <PageHeader title="I&I Dashboards" icon={BIApplicationIcon}> </PageHeader>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                    sx={{
                        '& .MuiTab-root': {
                        ...theme.typography.tabLabel, 
                        textTransform: 'none',
                        minHeight: 40,
                        fontWeight: 500,
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                        backgroundColor: `${theme.palette.Tab.inActive.bgColor} !important`,
                        color: `${theme.palette.Tab.inActive.color} !important`,
                        },
                        '& .MuiTab-root.Mui-selected': {
                        backgroundColor: `${theme.palette.Tab.Active.bgColor} !important`,
                        color: `${theme.palette.Tab.Active.color} !important`,
                        },
                    }}
                    >
                        <Tab label="NPI" {...a11yProps(0)} />
                        <Tab label="IT Control" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <AnalyticsVisualization
                        params={{
                            dashboardUrl: powerBIdashboardUrl.NPIDashboard,
                            className: 'powerBiIframeContainer',
                            otherParams: {
                                name: 'PowerBI'
                            },
                            seamless: true
                        }}
                    />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <AnalyticsVisualization
                        params={{
                            dashboardUrl: powerBIdashboardUrl.ITCDashboard,
                            className: 'powerBiIframeContainer',
                            otherParams: {
                                name: 'PowerBI'
                            },
                            seamless: true
                        }}
                    />
                </CustomTabPanel>
            </PageWrapper>
        // </div>
    );
};

export default NPIDashboards;
